// Ordering in the UI is dependant on the order of these values; do not reorder
export enum RecipientType {
    list,
    search,
    portfolio,
    mailingList,
    recommended,
    individual,
    email
}
